"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.infoBarReducer = infoBarReducer;
var _types = require("../game/types");
var _types2 = require("./types");
var initialState = {
  state: _types2.GameInfoBarState.Idle,
  value: "",
  defaultState: _types2.GameInfoBarState.Idle,
  defaultValue: "",
  settings: {
    hyperSpinMode: false,
    winIdleTimeout: undefined,
    idleTimeout: 1000
  }
};
function infoBarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.GAME_WINCOUNTER_SET:
    case _types.GAME_WINCOUNTER_ADD:
      {
        return Object.assign({}, state, {
          state: _types2.GameInfoBarState.Win,
          value: undefined
        });
      }
    case _types2.IB_SET_STATE:
      {
        return Object.assign({}, state, {
          state: action.payload,
          defaultState: action.payload // this can be null, if its something that cant be shown in text
        });
      }
    case _types2.IB_SET_SPECIAL:
      {
        return Object.assign({}, state, {
          state: _types2.GameInfoBarState.Special,
          value: action.payload // this can be null, if its something that cant be shown in text
        });
      }
    case _types2.IB_RESET_SPECIAL:
      {
        return Object.assign({}, state, {
          state: state.defaultState,
          value: state.defaultValue
        });
      }
  }
  return state;
}
//# sourceMappingURL=reducer.js.map